/**
 * Notification Details Formatter.
 *
 * @param {*} value
 * @param {*} row
 *
 * @returns {*}
 */
window.notificationDetailsFormatter = function(value, row) {
    let html = '';
    switch (row.type) {
        case "App\\Notifications\\Monitoring\\Task\\Failed":
            html += '<a href="'+route('admin.services.monitoring.show.index', row.data.monitoring.id)+'">';
            break;
        case "App\\Notifications\\Domains\\Statistics\\Report":
            html += '<a href="'+route('admin.domains.show.statistics.index', row.data.domain.id)+'">';
            break;
        default:
            html += '<a href="#">';
            break;
    }
    html += '<i class="fa fa-eye"></i>';
    html += '</a>';
    return html;
};
